import { render } from "./MemoryUsage.vue?vue&type=template&id=64318258"
import script from "./MemoryUsage.vue?vue&type=script&lang=js"
export * from "./MemoryUsage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__